import React, { useEffect, useState } from 'react';
import { platformService } from '../shared/services/platform.service';
import {
  STATUS,
  ADMINISTRATORS,
  ANALYSTS,
  FILTERS_STRINGS
} from '../shared/utils/constants';
import { useTranslation } from 'react-i18next';
import { appState } from '../AppState';
import { EnumList } from '../enum-list/EnumList';
import { TemplatePickerBaseProps } from '../templates/CustomComponents/DataSource/DataSourceForm';
import { ICustomPropertyListItem } from '../shared/interfaces/customproperties.interface';

export interface PickerListProps {
  dataSourceProps?: TemplatePickerBaseProps;
  propertyId: number;
}

export const CustomPropertyListItems = (props: PickerListProps) => {
  
  const currentState = appState();
  const {t} = useTranslation();
  const api = new platformService();
  const [hasAccess, setHasAccess] = useState(true);

  useEffect(()=>{
    let _hasAccess = currentState.userRoles.roles.includes(ADMINISTRATORS) || currentState.userRoles.roles.includes(ANALYSTS);
    setHasAccess(_hasAccess);
  },[]);

  const update = async (param:any) => {
    await api.updateCustomPropertyListItem(param);
  }

  const create = async (param:ICustomPropertyListItem) => {
    param.CustomPropertyId = props.propertyId;
    return await api.createCustomPropertyListItem(param);
  }


  const getList = async(param?:string) => {
    param = param?.startsWith('(') ? param : null;
    return await api.getCustomPropertyListItem(param ?? `${FILTERS_STRINGS.FILTERS_URL_PARAMS}%20and%20CustomPropertyId%20eq%20${props.propertyId}&v=${new Date().getTime()}`);
  }

  return (
    <EnumList
      typeName={'ServiceDesk.Core.Models.CustomProperties.CustomPropertyListItem'}
      updateData={update}
      createData={create}
      getList={getList}
      entityName={"CustomPropertyListItem"}
      title={STATUS.STATUS}
      pageTitle={t('status.title')}
      successMgs={t('status.changes-are-saved')}
      featchingListMsg={STATUS.GETTING_ALL_STATUSES}
      updateMsg={STATUS.UPDATING_STATUS}
      userRoleHasAccess={hasAccess}
      dataSourceProps={props?.dataSourceProps}
    />
  );
};
